import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const FamiliesPerHouse = () => {
    const { chartData } = useHouseholdChartsDataContext();


    return (
        <SimpleBars
            title={'Quantidade de Famílias no Domicílio'}
            horizontal={true}
            subtitles={chartData?.familiesPerHouse?.map((item) => item.description)}
            values={chartData?.familiesPerHouse?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
